// src/components/cofounder/CoFounderWidget.js
import React from 'react';
import CoFounderBubble from './CoFounderBubble';
import CoFounderPanel from './CoFounderPanel';

const CoFounderWidget = () => {
  return (
    <>
      <CoFounderBubble />
      <CoFounderPanel />
    </>
  );
};

export default CoFounderWidget;
